/* ============================================================
   Анимация появления блоков при скролле (.reveal → .in).
   Безопасно: без JS контент виден; жёсткий failsafe через 1.8с.
   ============================================================ */
import { qsa } from '../dom';

const observer = new IntersectionObserver(
  (entries, obs) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        obs.unobserve(e.target);
      }
    });
  },
  { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
);

/** Показать всё, что уже во вьюпорте (без ожидания скролла). */
export function revealVisible(): void {
  qsa('.reveal').forEach((el) => {
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.96 && r.bottom > 0) el.classList.add('in');
  });
}

export function initReveal(): void {
  qsa('.reveal').forEach((el) => {
    if (!el.classList.contains('in')) observer.observe(el);
  });
  revealVisible();
  window.addEventListener('load', revealVisible);
  // Failsafe: ничего не остаётся невидимым.
  window.setTimeout(() => qsa('.reveal').forEach((el) => el.classList.add('in')), 1800);
}
